import { READ } from '@wix/wix-data-client-common-standalone';
import { DEFAULT_PAGE_SIZE } from './pagination';
export const defaultDatasetConfiguration = {
    collectionName: null,
    readWriteType: READ,
    filter: null,
    sort: null,
    includes: null,
    nested: [],
    pageSize: DEFAULT_PAGE_SIZE,
    deferred: false,
};
//# sourceMappingURL=defaults.js.map